<script setup lang="ts">
import { INJECTION_KEYS } from '~/constants/injectionKeys';
import { ROUTE_NAMES } from '~/constants/routes';

// COMPOSABLES
const { tt } = useTypedI18n();
const localePath = useLocalePath();

// DATA
const orderData = inject(INJECTION_KEYS.ORDER_DATA);
const order = computed(() => orderData?.value?.order);
const { canEdit } = useOrderStatus(() => order.value);
</script>

<template>
    <div v-if="!!order" class="flex flex-col justify-center gap-y-4 bg-white p-4 md:flex-1 lg:flex-none lg:p-6">
        <UButton
            v-if="canEdit"
            :label="tt('account.orders.edit')"
            block
            size="lg"
            :ui="buttonResponsiveSizeUi('lg', 'xl')"
            :to="localePath({ name: ROUTE_NAMES.ACCOUNT_ORDER_EDIT, params: { id: order.id } })"
        />
        <UButton
            :label="tt('account.orders.action')"
            color="neutral"
            variant="outline"
            block
            size="lg"
            :ui="buttonResponsiveSizeUi('lg', 'xl')"
            :to="localePath({ name: ROUTE_NAMES.ACCOUNT_ORDER, params: { id: order.id } })"
        />
    </div>
</template>
